import { createElementBlock as N, openBlock as B, createElementVNode as G, defineComponent as K, computed as O, ref as S, onMounted as H, onUnmounted as ge, watchEffect as W, nextTick as J, watch as oe, provide as re, h as ie, Fragment as ce, inject as se, toRaw as I, normalizeClass as Y, resolveComponent as $, resolveDirective as ke, createVNode as j, withCtx as q, withDirectives as Ae, createCommentVNode as M, toDisplayString as ve, createBlock as ne, withModifiers as De, renderList as Fe, renderSlot as fe } from "vue";
import { N as Oe, f as $e } from "./vuelidate-04GJpzoE.js";
import { d as Ne } from "./debounce-CG9EzSwd.js";
import { h as je } from "./hide-label-cYI1fuDW.js";
import { r as Me, a as Ke } from "./XMarkIcon-CARouk43.js";
import { r as Ue } from "./ArrowPathIcon-B9ilFCuq.js";
import { t as ee, H as X, o as L, u as D, T as he, N as le, K as qe, a as k, S as Q } from "./dom-B5R6OWVp.js";
import { O as He, c as Xe } from "./focus-management-uTsAyIu4.js";
import { u as ze, p as Re, l as F, y as Ze, c as Ie, a as P, x as _e, C as Ge } from "./use-tracked-pointer-D7o8jeoa.js";
import { b as Je } from "./use-resolve-button-type-XAZYZJQ_.js";
import { p as Qe } from "./use-tree-walker-AStIFPaK.js";
import { d as We, e as Ye, f as et, a as tt } from "./use-controllable-BEb0o1U6.js";
import { _ as ot } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function lt(e, a) {
  return B(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    G("path", {
      "fill-rule": "evenodd",
      d: "M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function at() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function nt() {
  return /Android/gi.test(window.navigator.userAgent);
}
function ut() {
  return at() || nt();
}
function rt(e, a) {
  return e === a;
}
var it = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(it || {}), st = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(st || {}), dt = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(dt || {});
let Te = Symbol("ComboboxContext");
function te(e) {
  let a = se(Te, null);
  if (a === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, te), n;
  }
  return a;
}
let pt = K({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => rt }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: a, attrs: n, emit: s }) {
  let o = S(1), t = S(null), u = S(null), m = S(null), d = S(null), f = S({ static: !1, hold: !1 }), c = S([]), x = S(null), C = S(1), w = S(!1);
  function V(b = (h) => h) {
    let h = x.value !== null ? c.value[x.value] : null, y = He(b(c.value.slice()), (R) => L(R.dataRef.domRef)), g = h ? y.indexOf(h) : null;
    return g === -1 && (g = null), { options: y, activeOptionIndex: g };
  }
  let r = O(() => e.multiple ? 1 : 0), l = O(() => e.nullable), [i, v] = We(O(() => e.modelValue === void 0 ? D(r.value, { 1: [], 0: void 0 }) : e.modelValue), (b) => s("update:modelValue", b), O(() => e.defaultValue)), p = { comboboxState: o, value: i, mode: r, compare(b, h) {
    if (typeof e.by == "string") {
      let y = e.by;
      return (b == null ? void 0 : b[y]) === (h == null ? void 0 : h[y]);
    }
    return e.by(b, h);
  }, defaultValue: O(() => e.defaultValue), nullable: l, inputRef: u, labelRef: t, buttonRef: m, optionsRef: d, disabled: O(() => e.disabled), options: c, change(b) {
    v(b);
  }, activeOptionIndex: O(() => {
    if (w.value && x.value === null && c.value.length > 0) {
      let b = c.value.findIndex((h) => !h.dataRef.disabled);
      if (b !== -1) return b;
    }
    return x.value;
  }), activationTrigger: C, optionsPropsRef: f, closeCombobox() {
    w.value = !1, !e.disabled && o.value !== 1 && (o.value = 1, x.value = null);
  }, openCombobox() {
    if (w.value = !0, e.disabled || o.value === 0) return;
    let b = c.value.findIndex((h) => {
      let y = I(h.dataRef.value);
      return D(r.value, { 0: () => p.compare(I(p.value.value), I(y)), 1: () => I(p.value.value).some((g) => p.compare(I(g), I(y))) });
    });
    b !== -1 && (x.value = b), o.value = 0;
  }, goToOption(b, h, y) {
    if (w.value = !1, e.disabled || d.value && !f.value.static && o.value === 1) return;
    let g = V();
    if (g.activeOptionIndex === null) {
      let T = g.options.findIndex((z) => !z.dataRef.disabled);
      T !== -1 && (g.activeOptionIndex = T);
    }
    let R = _e(b === P.Specific ? { focus: P.Specific, id: h } : { focus: b }, { resolveItems: () => g.options, resolveActiveIndex: () => g.activeOptionIndex, resolveId: (T) => T.id, resolveDisabled: (T) => T.dataRef.disabled });
    x.value = R, C.value = y ?? 1, c.value = g.options;
  }, selectOption(b) {
    let h = c.value.find((g) => g.id === b);
    if (!h) return;
    let { dataRef: y } = h;
    v(D(r.value, { 0: () => y.value, 1: () => {
      let g = I(p.value.value).slice(), R = I(y.value), T = g.findIndex((z) => p.compare(R, I(z)));
      return T === -1 ? g.push(R) : g.splice(T, 1), g;
    } }));
  }, selectActiveOption() {
    if (p.activeOptionIndex.value === null) return;
    let { dataRef: b, id: h } = c.value[p.activeOptionIndex.value];
    v(D(r.value, { 0: () => b.value, 1: () => {
      let y = I(p.value.value).slice(), g = I(b.value), R = y.findIndex((T) => p.compare(g, I(T)));
      return R === -1 ? y.push(g) : y.splice(R, 1), y;
    } })), p.goToOption(P.Specific, h);
  }, registerOption(b, h) {
    let y = { id: b, dataRef: h }, g = V((R) => [...R, y]);
    if (x.value === null) {
      let R = h.value.value;
      D(r.value, { 0: () => p.compare(I(p.value.value), I(R)), 1: () => I(p.value.value).some((T) => p.compare(I(T), I(R))) }) && (g.activeOptionIndex = g.options.indexOf(y));
    }
    c.value = g.options, x.value = g.activeOptionIndex, C.value = 1;
  }, unregisterOption(b) {
    var h;
    p.activeOptionIndex.value !== null && ((h = p.options.value[p.activeOptionIndex.value]) == null ? void 0 : h.id) === b && (w.value = !0);
    let y = V((g) => {
      let R = g.findIndex((T) => T.id === b);
      return R !== -1 && g.splice(R, 1), g;
    });
    c.value = y.options, x.value = y.activeOptionIndex, C.value = 1;
  } };
  Ze([u, m, d], () => p.closeCombobox(), O(() => o.value === 0)), re(Te, p), Ie(O(() => D(o.value, { 0: F.Open, 1: F.Closed })));
  let E = O(() => p.activeOptionIndex.value === null ? null : c.value[p.activeOptionIndex.value].dataRef.value), A = O(() => {
    var b;
    return (b = L(u)) == null ? void 0 : b.closest("form");
  });
  return H(() => {
    oe([A], () => {
      if (!A.value || e.defaultValue === void 0) return;
      function b() {
        p.change(e.defaultValue);
      }
      return A.value.addEventListener("reset", b), () => {
        var h;
        (h = A.value) == null || h.removeEventListener("reset", b);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: b, disabled: h, form: y, ...g } = e, R = { open: o.value === 0, disabled: h, activeIndex: p.activeOptionIndex.value, activeOption: E.value, value: i.value };
    return ie(ce, [...b != null && i.value != null ? Ye({ [b]: i.value }).map(([T, z]) => ie(et, qe({ features: tt.Hidden, key: T, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: y, name: T, value: z }))) : [], X({ theirProps: { ...n, ...he(g, ["modelValue", "defaultValue", "nullable", "multiple", "onUpdate:modelValue", "by"]) }, ourProps: {}, slot: R, slots: a, attrs: n, name: "Combobox" })]);
  };
} }), vt = K({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${ee()}` } }, setup(e, { attrs: a, slots: n }) {
  let s = te("ComboboxLabel");
  function o() {
    var t;
    (t = L(s.inputRef)) == null || t.focus({ preventScroll: !0 });
  }
  return () => {
    let t = { open: s.comboboxState.value === 0, disabled: s.disabled.value }, { id: u, ...m } = e, d = { id: u, ref: s.labelRef, onClick: o };
    return X({ ourProps: d, theirProps: m, slot: t, attrs: a, slots: n, name: "ComboboxLabel" });
  };
} }), ft = K({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${ee()}` } }, setup(e, { attrs: a, slots: n, expose: s }) {
  let o = te("ComboboxButton");
  s({ el: o.buttonRef, $el: o.buttonRef });
  function t(d) {
    o.disabled.value || (o.comboboxState.value === 0 ? o.closeCombobox() : (d.preventDefault(), o.openCombobox()), J(() => {
      var f;
      return (f = L(o.inputRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    }));
  }
  function u(d) {
    switch (d.key) {
      case k.ArrowDown:
        d.preventDefault(), d.stopPropagation(), o.comboboxState.value === 1 && o.openCombobox(), J(() => {
          var f;
          return (f = o.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
      case k.ArrowUp:
        d.preventDefault(), d.stopPropagation(), o.comboboxState.value === 1 && (o.openCombobox(), J(() => {
          o.value.value || o.goToOption(P.Last);
        })), J(() => {
          var f;
          return (f = o.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
      case k.Escape:
        if (o.comboboxState.value !== 0) return;
        d.preventDefault(), o.optionsRef.value && !o.optionsPropsRef.value.static && d.stopPropagation(), o.closeCombobox(), J(() => {
          var f;
          return (f = o.inputRef.value) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let m = Je(O(() => ({ as: e.as, type: a.type })), o.buttonRef);
  return () => {
    var d, f;
    let c = { open: o.comboboxState.value === 0, disabled: o.disabled.value, value: o.value.value }, { id: x, ...C } = e, w = { ref: o.buttonRef, id: x, type: m.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (d = L(o.optionsRef)) == null ? void 0 : d.id, "aria-expanded": o.disabled.value ? void 0 : o.comboboxState.value === 0, "aria-labelledby": o.labelRef.value ? [(f = L(o.labelRef)) == null ? void 0 : f.id, x].join(" ") : void 0, disabled: o.disabled.value === !0 ? !0 : void 0, onKeydown: u, onClick: t };
    return X({ ourProps: w, theirProps: C, slot: c, attrs: a, slots: n, name: "ComboboxButton" });
  };
} }), bt = K({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${ee()}` } }, emits: { change: (e) => !0 }, setup(e, { emit: a, attrs: n, slots: s, expose: o }) {
  let t = te("ComboboxInput"), u = { value: !1 };
  o({ el: t.inputRef, $el: t.inputRef });
  let m = O(() => {
    var r;
    let l = t.value.value;
    return L(t.inputRef) ? typeof e.displayValue < "u" && l !== void 0 ? (r = e.displayValue(l)) != null ? r : "" : typeof l == "string" ? l : "" : "";
  });
  H(() => {
    oe([m, t.comboboxState], ([r, l], [i, v]) => {
      if (u.value) return;
      let p = L(t.inputRef);
      p && (v === 0 && l === 1 || r !== i) && (p.value = r);
    }, { immediate: !0 }), oe([t.comboboxState], ([r], [l]) => {
      if (r === 0 && l === 1) {
        let i = L(t.inputRef);
        if (!i) return;
        let v = i.value, { selectionStart: p, selectionEnd: E, selectionDirection: A } = i;
        i.value = "", i.value = v, A !== null ? i.setSelectionRange(p, E, A) : i.setSelectionRange(p, E);
      }
    });
  });
  let d = S(!1);
  function f() {
    d.value = !0;
  }
  function c() {
    setTimeout(() => {
      d.value = !1;
    });
  }
  function x(r) {
    switch (u.value = !0, r.key) {
      case k.Backspace:
      case k.Delete:
        if (t.mode.value !== 0 || !t.nullable.value) return;
        let l = r.currentTarget;
        requestAnimationFrame(() => {
          if (l.value === "") {
            t.change(null);
            let i = L(t.optionsRef);
            i && (i.scrollTop = 0), t.goToOption(P.Nothing);
          }
        });
        break;
      case k.Enter:
        if (u.value = !1, t.comboboxState.value !== 0 || d.value) return;
        if (r.preventDefault(), r.stopPropagation(), t.activeOptionIndex.value === null) {
          t.closeCombobox();
          return;
        }
        t.selectActiveOption(), t.mode.value === 0 && t.closeCombobox();
        break;
      case k.ArrowDown:
        return u.value = !1, r.preventDefault(), r.stopPropagation(), D(t.comboboxState.value, { 0: () => t.goToOption(P.Next), 1: () => t.openCombobox() });
      case k.ArrowUp:
        return u.value = !1, r.preventDefault(), r.stopPropagation(), D(t.comboboxState.value, { 0: () => t.goToOption(P.Previous), 1: () => {
          t.openCombobox(), J(() => {
            t.value.value || t.goToOption(P.Last);
          });
        } });
      case k.Home:
        if (r.shiftKey) break;
        return u.value = !1, r.preventDefault(), r.stopPropagation(), t.goToOption(P.First);
      case k.PageUp:
        return u.value = !1, r.preventDefault(), r.stopPropagation(), t.goToOption(P.First);
      case k.End:
        if (r.shiftKey) break;
        return u.value = !1, r.preventDefault(), r.stopPropagation(), t.goToOption(P.Last);
      case k.PageDown:
        return u.value = !1, r.preventDefault(), r.stopPropagation(), t.goToOption(P.Last);
      case k.Escape:
        if (u.value = !1, t.comboboxState.value !== 0) return;
        r.preventDefault(), t.optionsRef.value && !t.optionsPropsRef.value.static && r.stopPropagation(), t.closeCombobox();
        break;
      case k.Tab:
        if (u.value = !1, t.comboboxState.value !== 0) return;
        t.mode.value === 0 && t.selectActiveOption(), t.closeCombobox();
        break;
    }
  }
  function C(r) {
    t.openCombobox(), a("change", r);
  }
  function w() {
    u.value = !1;
  }
  let V = O(() => {
    var r, l, i, v;
    return (v = (i = (l = e.defaultValue) != null ? l : t.defaultValue.value !== void 0 ? (r = e.displayValue) == null ? void 0 : r.call(e, t.defaultValue.value) : null) != null ? i : t.defaultValue.value) != null ? v : "";
  });
  return () => {
    var r, l, i, v, p, E;
    let A = { open: t.comboboxState.value === 0 }, { id: b, displayValue: h, onChange: y, ...g } = e, R = { "aria-controls": (r = t.optionsRef.value) == null ? void 0 : r.id, "aria-expanded": t.disabled.value ? void 0 : t.comboboxState.value === 0, "aria-activedescendant": t.activeOptionIndex.value === null || (l = t.options.value[t.activeOptionIndex.value]) == null ? void 0 : l.id, "aria-labelledby": (p = (i = L(t.labelRef)) == null ? void 0 : i.id) != null ? p : (v = L(t.buttonRef)) == null ? void 0 : v.id, "aria-autocomplete": "list", id: b, onCompositionstart: f, onCompositionend: c, onKeydown: x, onInput: C, onBlur: w, role: "combobox", type: (E = n.type) != null ? E : "text", tabIndex: 0, ref: t.inputRef, defaultValue: V.value, disabled: t.disabled.value === !0 ? !0 : void 0 };
    return X({ ourProps: R, theirProps: g, slot: A, attrs: n, slots: s, features: le.RenderStrategy | le.Static, name: "ComboboxInput" });
  };
} }), ct = K({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: a, slots: n, expose: s }) {
  let o = te("ComboboxOptions"), t = `headlessui-combobox-options-${ee()}`;
  s({ el: o.optionsRef, $el: o.optionsRef }), W(() => {
    o.optionsPropsRef.value.static = e.static;
  }), W(() => {
    o.optionsPropsRef.value.hold = e.hold;
  });
  let u = Re(), m = O(() => u !== null ? (u.value & F.Open) === F.Open : o.comboboxState.value === 0);
  return Qe({ container: O(() => L(o.optionsRef)), enabled: O(() => o.comboboxState.value === 0), accept(d) {
    return d.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : d.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(d) {
    d.setAttribute("role", "none");
  } }), () => {
    var d, f, c;
    let x = { open: o.comboboxState.value === 0 }, C = { "aria-labelledby": (c = (d = L(o.labelRef)) == null ? void 0 : d.id) != null ? c : (f = L(o.buttonRef)) == null ? void 0 : f.id, id: t, ref: o.optionsRef, role: "listbox", "aria-multiselectable": o.mode.value === 1 ? !0 : void 0 }, w = he(e, ["hold"]);
    return X({ ourProps: C, theirProps: w, slot: x, attrs: a, slots: n, features: le.RenderStrategy | le.Static, visible: m.value, name: "ComboboxOptions" });
  };
} }), mt = K({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 } }, setup(e, { slots: a, attrs: n, expose: s }) {
  let o = te("ComboboxOption"), t = `headlessui-combobox-option-${ee()}`, u = S(null);
  s({ el: u, $el: u });
  let m = O(() => o.activeOptionIndex.value !== null ? o.options.value[o.activeOptionIndex.value].id === t : !1), d = O(() => D(o.mode.value, { 0: () => o.compare(I(o.value.value), I(e.value)), 1: () => I(o.value.value).some((l) => o.compare(I(l), I(e.value))) })), f = O(() => ({ disabled: e.disabled, value: e.value, domRef: u }));
  H(() => o.registerOption(t, f)), ge(() => o.unregisterOption(t)), W(() => {
    o.comboboxState.value === 0 && m.value && o.activationTrigger.value !== 0 && J(() => {
      var l, i;
      return (i = (l = L(u)) == null ? void 0 : l.scrollIntoView) == null ? void 0 : i.call(l, { block: "nearest" });
    });
  });
  function c(l) {
    if (e.disabled) return l.preventDefault();
    o.selectOption(t), o.mode.value === 0 && o.closeCombobox(), ut() || requestAnimationFrame(() => {
      var i;
      return (i = L(o.inputRef)) == null ? void 0 : i.focus();
    });
  }
  function x() {
    if (e.disabled) return o.goToOption(P.Nothing);
    o.goToOption(P.Specific, t);
  }
  let C = ze();
  function w(l) {
    C.update(l);
  }
  function V(l) {
    C.wasMoved(l) && (e.disabled || m.value || o.goToOption(P.Specific, t, 0));
  }
  function r(l) {
    C.wasMoved(l) && (e.disabled || m.value && (o.optionsPropsRef.value.hold || o.goToOption(P.Nothing)));
  }
  return () => {
    let { disabled: l } = e, i = { active: m.value, selected: d.value, disabled: l }, v = { id: t, ref: u, role: "option", tabIndex: l === !0 ? void 0 : -1, "aria-disabled": l === !0 ? !0 : void 0, "aria-selected": d.value, disabled: void 0, onClick: c, onFocus: x, onPointerenter: w, onMouseenter: w, onPointermove: V, onMousemove: V, onPointerleave: r, onMouseleave: r };
    return X({ ourProps: v, theirProps: e, slot: i, attrs: n, slots: a, name: "ComboboxOption" });
  };
} });
function ye() {
  let e = [], a = { addEventListener(n, s, o, t) {
    return n.addEventListener(s, o, t), a.add(() => n.removeEventListener(s, o, t));
  }, requestAnimationFrame(...n) {
    let s = requestAnimationFrame(...n);
    a.add(() => cancelAnimationFrame(s));
  }, nextFrame(...n) {
    a.requestAnimationFrame(() => {
      a.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let s = setTimeout(...n);
    a.add(() => clearTimeout(s));
  }, style(n, s, o) {
    let t = n.style.getPropertyValue(s);
    return Object.assign(n.style, { [s]: o }), this.add(() => {
      Object.assign(n.style, { [s]: t });
    });
  }, group(n) {
    let s = ye();
    return n(s), this.add(() => s.dispose());
  }, add(n) {
    return e.push(n), () => {
      let s = e.indexOf(n);
      if (s >= 0) for (let o of e.splice(s, 1)) o();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return a;
}
function gt(e) {
  let a = { called: !1 };
  return (...n) => {
    if (!a.called) return a.called = !0, e(...n);
  };
}
function be(e, ...a) {
  e && a.length > 0 && e.classList.add(...a);
}
function ue(e, ...a) {
  e && a.length > 0 && e.classList.remove(...a);
}
var me = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(me || {});
function ht(e, a) {
  let n = ye();
  if (!e) return n.dispose;
  let { transitionDuration: s, transitionDelay: o } = getComputedStyle(e), [t, u] = [s, o].map((m) => {
    let [d = 0] = m.split(",").filter(Boolean).map((f) => f.includes("ms") ? parseFloat(f) : parseFloat(f) * 1e3).sort((f, c) => c - f);
    return d;
  });
  return t !== 0 ? n.setTimeout(() => a("finished"), t + u) : a("finished"), n.add(() => a("cancelled")), n.dispose;
}
function we(e, a, n, s, o, t) {
  let u = ye(), m = t !== void 0 ? gt(t) : () => {
  };
  return ue(e, ...o), be(e, ...a, ...n), u.nextFrame(() => {
    ue(e, ...n), be(e, ...s), u.add(ht(e, (d) => (ue(e, ...s, ...a), be(e, ...o), m(d))));
  }), u.add(() => ue(e, ...a, ...n, ...s, ...o)), u.add(() => m("cancelled")), u.dispose;
}
function _(e = "") {
  return e.split(" ").filter((a) => a.trim().length > 1);
}
let xe = Symbol("TransitionContext");
var yt = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(yt || {});
function xt() {
  return se(xe, null) !== null;
}
function St() {
  let e = se(xe, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Ct() {
  let e = se(Se, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Se = Symbol("NestingContext");
function de(e) {
  return "children" in e ? de(e.children) : e.value.filter(({ state: a }) => a === "visible").length > 0;
}
function Le(e) {
  let a = S([]), n = S(!1);
  H(() => n.value = !0), ge(() => n.value = !1);
  function s(t, u = Q.Hidden) {
    let m = a.value.findIndex(({ id: d }) => d === t);
    m !== -1 && (D(u, { [Q.Unmount]() {
      a.value.splice(m, 1);
    }, [Q.Hidden]() {
      a.value[m].state = "hidden";
    } }), !de(a) && n.value && (e == null || e()));
  }
  function o(t) {
    let u = a.value.find(({ id: m }) => m === t);
    return u ? u.state !== "visible" && (u.state = "visible") : a.value.push({ id: t, state: "visible" }), () => s(t, Q.Unmount);
  }
  return { children: a, register: o, unregister: s };
}
let Ee = le.RenderStrategy, Ot = K({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: a, attrs: n, slots: s, expose: o }) {
  let t = S(0);
  function u() {
    t.value |= F.Opening, a("beforeEnter");
  }
  function m() {
    t.value &= ~F.Opening, a("afterEnter");
  }
  function d() {
    t.value |= F.Closing, a("beforeLeave");
  }
  function f() {
    t.value &= ~F.Closing, a("afterLeave");
  }
  if (!xt() && Ge()) return () => ie(Pe, { ...e, onBeforeEnter: u, onAfterEnter: m, onBeforeLeave: d, onAfterLeave: f }, s);
  let c = S(null), x = O(() => e.unmount ? Q.Unmount : Q.Hidden);
  o({ el: c, $el: c });
  let { show: C, appear: w } = St(), { register: V, unregister: r } = Ct(), l = S(C.value ? "visible" : "hidden"), i = { value: !0 }, v = ee(), p = { value: !1 }, E = Le(() => {
    !p.value && l.value !== "hidden" && (l.value = "hidden", r(v), f());
  });
  H(() => {
    let U = V(v);
    ge(U);
  }), W(() => {
    if (x.value === Q.Hidden && v) {
      if (C.value && l.value !== "visible") {
        l.value = "visible";
        return;
      }
      D(l.value, { hidden: () => r(v), visible: () => V(v) });
    }
  });
  let A = _(e.enter), b = _(e.enterFrom), h = _(e.enterTo), y = _(e.entered), g = _(e.leave), R = _(e.leaveFrom), T = _(e.leaveTo);
  H(() => {
    W(() => {
      if (l.value === "visible") {
        let U = L(c);
        if (U instanceof Comment && U.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function z(U) {
    let pe = i.value && !w.value, Z = L(c);
    !Z || !(Z instanceof HTMLElement) || pe || (p.value = !0, C.value && u(), C.value || d(), U(C.value ? we(Z, A, b, h, y, (ae) => {
      p.value = !1, ae === me.Finished && m();
    }) : we(Z, g, R, T, y, (ae) => {
      p.value = !1, ae === me.Finished && (de(E) || (l.value = "hidden", r(v), f()));
    })));
  }
  return H(() => {
    oe([C], (U, pe, Z) => {
      z(Z), i.value = !1;
    }, { immediate: !0 });
  }), re(Se, E), Ie(O(() => D(l.value, { visible: F.Open, hidden: F.Closed }) | t.value)), () => {
    let { appear: U, show: pe, enter: Z, enterFrom: ae, enterTo: At, entered: Dt, leave: Ft, leaveFrom: $t, leaveTo: Nt, ...Ce } = e, Ve = { ref: c }, Be = { ...Ce, ...w.value && C.value && Xe.isServer ? { class: Y([n.class, Ce.class, ...A, ...b]) } : {} };
    return X({ theirProps: Be, ourProps: Ve, slot: {}, slots: s, attrs: n, features: Ee, visible: l.value === "visible", name: "TransitionChild" });
  };
} }), wt = Ot, Pe = K({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: a, attrs: n, slots: s }) {
  let o = Re(), t = O(() => e.show === null && o !== null ? (o.value & F.Open) === F.Open : e.show);
  W(() => {
    if (![!0, !1].includes(t.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let u = S(t.value ? "visible" : "hidden"), m = Le(() => {
    u.value = "hidden";
  }), d = S(!0), f = { show: t, appear: O(() => e.appear || !d.value) };
  return H(() => {
    W(() => {
      d.value = !1, t.value ? u.value = "visible" : de(m) || (u.value = "hidden");
    });
  }), re(Se, m), re(xe, f), () => {
    let c = he(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), x = { unmount: e.unmount };
    return X({ ourProps: { ...x, as: "template" }, theirProps: {}, slot: {}, slots: { ...s, default: () => [ie(wt, { onBeforeEnter: () => a("beforeEnter"), onAfterEnter: () => a("afterEnter"), onBeforeLeave: () => a("beforeLeave"), onAfterLeave: () => a("afterLeave"), ...n, ...x, ...c }, s.default)] }, attrs: {}, features: Ee, visible: u.value === "visible", name: "Transition" });
  };
} });
const Rt = K({
  components: {
    Combobox: pt,
    ComboboxInput: bt,
    ComboboxOptions: ct,
    ComboboxOption: mt,
    ComboboxButton: ft,
    ComboboxLabel: vt,
    TransitionRoot: Pe,
    ChevronUpDownIcon: lt,
    ArrowPathIcon: Ue,
    XMarkIcon: Ke,
    CheckIcon: Me
  },
  directives: { hideLabelDirective: je },
  props: {
    modelValue: [Object, String, Boolean, Array, Number, Oe],
    /** property name or Function */
    optionsLabel: {
      type: [String, Function],
      default: () => (e) => e
    },
    multiple: Boolean,
    nullable: Boolean,
    disabled: Boolean,
    /** set to null to execute search on mount or reload data */
    count: [Number, Oe],
    optionsKey: { type: [String, Function], default: () => "id" },
    optionsSearch: Function,
    optionsDisabled: Function,
    placeholder: String,
    top: Boolean,
    validation: Object
  },
  emits: ["update:modelValue", "change", "update:count"],
  slots: Object,
  setup(e, { emit: a }) {
    const n = (l) => l == null ? "" : typeof e.optionsLabel == "string" ? l[e.optionsLabel] : e.optionsLabel(l), s = S(!1), o = S(!1), t = S([]), u = S(""), m = S(e.top === !0), d = S(), f = S();
    let c;
    async function x(l, i) {
      var v, p;
      if (e.optionsSearch) {
        if (l === !0) {
          if (c === void 0)
            u.value = ((v = f.value) == null ? void 0 : v.$el.value) || "";
          else if (!i)
            return;
        } else {
          if (!o.value && !i) return;
          u.value = ((p = l == null ? void 0 : l.target) == null ? void 0 : p.value) || "";
        }
        !i && c === u.value || (s.value = !0, t.value = await e.optionsSearch(u.value), c = u.value, s.value = !1, a("update:count", t.value.length));
      }
    }
    const C = (l) => {
      var i, v, p;
      if (!o.value) {
        if (l.target && ((i = l.target) == null || i.select()), l.target && e.top !== !0) {
          const E = l.target;
          E && (m.value = (E.getClientRects()[0].bottom || 0) + 150 > window.innerHeight);
        }
        (p = (v = d.value) == null ? void 0 : v.$el) == null || p.click();
      }
    }, w = S(!1), V = () => {
      w.value = !0, setTimeout(() => {
        var l, i;
        (i = (l = d.value) == null ? void 0 : l.$el) == null || i.click(), setTimeout(() => {
          var v, p;
          (p = (v = f.value) == null ? void 0 : v.$el) == null || p.blur(), setTimeout(() => {
            w.value = !1;
          });
        });
      });
    }, r = O({
      get() {
        return e.modelValue || null;
      },
      set(l) {
        c = null, a("update:modelValue", l || null), a("change", l || null), e.multiple || V();
      }
    });
    return oe(() => e.count, (l) => {
      l === null && x(!0, !0);
    }, { immediate: !0 }), {
      isOpen: o,
      model: r,
      searching: s,
      noValue: O(() => e.multiple ? r.value.length === 0 : !r.value),
      opts: t,
      optToLabel: n,
      optsLabel: (l) => Array.isArray(l) ? l.map((i) => n(i)).join(", ") : n(l),
      optsKey: typeof e.optionsKey == "string" ? (l) => l && l[e.optionsKey] : e.optionsKey,
      optsCompare: typeof e.optionsKey == "string" ? e.optionsKey : (l, i) => (!l || !i) && l == i || e.optionsKey(l) === e.optionsKey(i),
      query: u,
      search: x,
      searchDebounce: Ne(x),
      refButtton: d,
      refInput: f,
      hideDuringclose: w,
      openOn: C,
      top: m,
      NO_RESULT: $e.translate("components.combobox.no_result")
    };
  }
}), It = { class: "tx-combobox" }, Tt = { class: "tt-relative tt-mt-1" }, Lt = {
  key: 0,
  class: "tt-text-gray-400 tt-text-xs"
}, Et = ["for"], Pt = {
  key: 0,
  class: "tt-relative tt-cursor-default tt-select-none tt-py-2 tt-px-4 tt-text-gray-700"
}, Vt = { class: "tt-select-none" }, Bt = { class: "tt-select-none" };
function kt(e, a, n, s, o, t) {
  const u = $("ComboboxLabel"), m = $("ComboboxInput"), d = $("ArrowPathIcon"), f = $("ChevronUpDownIcon"), c = $("ComboboxButton"), x = $("XMarkIcon"), C = $("CheckIcon"), w = $("ComboboxOption"), V = $("ComboboxOptions"), r = $("TransitionRoot"), l = $("Combobox", !0), i = ke("hide-label-directive");
  return B(), N("div", It, [
    j(l, {
      modelValue: e.model,
      "onUpdate:modelValue": a[6] || (a[6] = (v) => e.model = v),
      multiple: e.$props.multiple,
      nullable: !e.$props.disabled && e.$props.nullable,
      disabled: e.$props.disabled,
      by: e.optsCompare
    }, {
      default: q(() => [
        Ae((B(), N("div", Tt, [
          j(u, {
            for: "combobox" + e.$.uid,
            ref: "label",
            class: "tw-input-label"
          }, {
            default: q(() => [
              G("span", null, ve(e.$props.placeholder), 1),
              e.validation && e.validation.required ? (B(), N("span", Lt, " ∗ ")) : M("", !0)
            ]),
            _: 1
          }, 8, ["for"]),
          G("div", {
            class: Y(["tt-relative tt-w-full tt-bg-white tt-border-2 tt-border-gray-200 tt-rounded-lg tt-text-left tt-cursor-default sm:tt-text-sm", [e.validation && e.validation.$errors.length ? "tt-border-red-300 tt-text-red-900 tt-placeholder-red-300 focus:tt-outline-none focus:tt-ring-red-500 focus:tt-border-red-500" : ""]])
          }, [
            j(m, {
              id: "combobox" + e.$.uid,
              ref: "refInput",
              class: "tt-w-full tt-py-2.5 tt-border-none tt-pl-3 tt-rounded-lg tt-text-sm tt-leading-5 tt-text-gray-900 focus:tt-ring-0",
              displayValue: e.optsLabel,
              modelValue: e.query,
              "onUpdate:modelValue": a[0] || (a[0] = (v) => e.query = v),
              placeholder: "      " + e.placeholder,
              disabled: e.$props.disabled,
              onChange: e.searchDebounce,
              onFocusin: e.openOn
            }, null, 8, ["id", "displayValue", "modelValue", "placeholder", "disabled", "onChange", "onFocusin"]),
            e.noValue ? (B(), N("span", {
              key: 0,
              for: "notcombobox" + e.$.uid,
              class: "tt-absolute font-material-symbols-outlined tt-text-gray-400 tt-text-lg",
              style: { bottom: "6px", left: "10px" }
            }, "", 8, Et)) : M("", !0),
            j(c, {
              ref: "refButtton",
              class: "tt-absolute tt-inset-y-0 tt-rounded-r-lg tt-right-0 tt-flex tt-items-center tt-pr-2 tt-bg-white",
              onClick: a[1] || (a[1] = (v) => e.search(!0))
            }, {
              default: q(() => [
                e.searching ? (B(), ne(d, {
                  key: 0,
                  class: "tt-animate-spin tt-h-5 tt-w-5 tt-text-gray-400 tt-bg-white tt-z-50",
                  "aria-hidden": "true"
                })) : M("", !0),
                j(f, {
                  class: "tt-h-5 tt-w-5 tt-text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 512),
            !e.$props.disabled && e.$props.nullable && !e.noValue ? (B(), N("button", {
              key: 1,
              class: "tt-absolute tt-inset-y-0 tt-right-5 tt-flex tt-items-center tt-pr-2",
              onClick: a[2] || (a[2] = De((v) => e.$props.multiple ? e.model = [] : e.model = void 0, ["prevent"]))
            }, [
              j(x, {
                class: "tt-h-4 tt-w-4 tt-text-gray-400",
                "aria-hidden": "true"
              })
            ])) : M("", !0)
          ], 2),
          j(r, {
            onAfterLeave: a[3] || (a[3] = (v) => e.query = ""),
            onBeforeEnter: a[4] || (a[4] = (v) => e.isOpen = !0),
            onBeforeLeave: a[5] || (a[5] = (v) => e.isOpen = !1)
          }, {
            default: q(() => [
              j(V, {
                class: Y([{ hidden: e.hideDuringclose, "bottom-full": e.top }, "tt-absolute tt-z-20 tt-m-1 tt-w-full tt-py-1 tt-rounded-lg tt-bg-white tt-text-base tt-ring-1 tt-ring-black tt-ring-opacity-5 focus:tt-outline-none sm:tt-text-sm"])
              }, {
                default: q(() => [
                  e.opts.length === 0 ? (B(), N("div", Pt, ve(e.NO_RESULT), 1)) : M("", !0),
                  (B(!0), N(ce, null, Fe(e.opts, (v) => (B(), ne(w, {
                    as: "template",
                    key: e.optsKey(v),
                    value: v,
                    disabled: !(!e.$props.optionsDisabled || !e.$props.optionsDisabled(v))
                  }, {
                    default: q(({ selected: p, active: E }) => [
                      G("li", {
                        class: Y(["tt-relative tt-cursor-default tt-select-none tt-py-2 tt-px-3", E ? "tw-bg-primary tt-text-white" : "tt-text-gray-900"])
                      }, [
                        fe(e.$slots, "default", {
                          opt: v,
                          selected: p,
                          active: E
                        }),
                        e.$slots.default ? M("", !0) : (B(), N(ce, { key: 0 }, [
                          G("span", {
                            class: Y(["tt-block tt-truncate", p ? "tt-font-medium" : "tt-font-normal"])
                          }, ve(e.optToLabel(v)), 3),
                          p ? (B(), N("span", {
                            key: 0,
                            class: Y(["tt-absolute tt-inset-y-0 tt-right-0 tt-flex tt-items-center tt-pr-3", E ? "tt-text-white" : "tt-text-gray-900"])
                          }, [
                            j(C, {
                              class: "tt-h-5 tt-w-5",
                              "aria-hidden": "true"
                            })
                          ], 2)) : M("", !0)
                        ], 64))
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value", "disabled"]))), 128)),
                  "end" in e.$slots ? (B(), ne(w, {
                    as: "template",
                    key: "slotend"
                  }, {
                    default: q(({ active: v }) => [
                      G("li", Vt, [
                        fe(e.$slots, "end", { active: v })
                      ])
                    ]),
                    _: 3
                  })) : M("", !0),
                  "end1" in e.$slots ? (B(), ne(w, {
                    as: "template",
                    key: "slotend1"
                  }, {
                    default: q(({ active: v }) => [
                      G("li", Bt, [
                        fe(e.$slots, "end1", { active: v })
                      ])
                    ]),
                    _: 3
                  })) : M("", !0)
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          })
        ])), [
          [i, "combobox" + e.$.uid]
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "multiple", "nullable", "disabled", "by"])
  ]);
}
const Wt = /* @__PURE__ */ ot(Rt, [["render", kt]]);
export {
  Wt as default
};
//# sourceMappingURL=Combobox-zKa2lri2.js.map
